// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/paragraph/ParagraphTestimonial.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/paragraph/ParagraphTestimonial.tsx");
  import.meta.hot.lastModified = "1732036225887.1907";
}
// REMIX HMR END

import clsx from "clsx";
import { Image } from "@unpic/react";
import htmlParser from "~/components/helpers/htmlParser";
import Heading from "../Heading";
/**
 * Renders a Testimonial section styled accordingly to the background color.
 * 
 * @param titleOptional The tile of the section.
 * @param name The name of the person giving the testimonial. 
 * @param quote The testimony itself.
 * @param position The Job position this person has in the company.
 * @param company The company where this person works.
 * @param imageOptional An image representing the one giving the testimony.
 * @param background The color of the background, this impacts font color.
 * 
 * @returns A styled Testimonial section.
 * 
 */

export default function Testimonial({
  titleOptional,
  name,
  quote,
  position,
  company,
  imageOptional,
  background
}) {
  const quoteParsed = htmlParser({
    html: quote.processed || "",
    theme: background || "light"
  });
  const textColor = background === "dark" ? "text-neutral-100" : "text-primary-700";
  return <section className={clsx("w-full flex flex-col items-center text-center my-14", textColor)}>
      {titleOptional && <Heading tag="h2">{titleOptional}</Heading>}
      {imageOptional && <Image className="max-w-[128px] w-15 rounded-full mb-4" src={imageOptional.mediaImage.url} layout="constrained" alt={imageOptional.mediaImage.alt} width={imageOptional.mediaImage.width} height={imageOptional.mediaImage.height} />}
      <Heading tag="h3">{name}</Heading>
      <div className="flex mb-4">
        <span>{company}</span>
        <span>&nbsp;{`(${position})`}</span>
      </div>
      <div className={clsx("max-w-[500px] italic", background === "dark" ? "wysiwyg-dark" : "wysiwyg")} dangerouslySetInnerHTML={{
      __html: quoteParsed
    }}>
      </div>
    </section>;
}
_c = Testimonial;
var _c;
$RefreshReg$(_c, "Testimonial");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;